import { app } from '../../../../app';
import { Controller } from './password-authentication-policy.controller';

app.component('passwordAuthenticationPolicy', {
    bindings:{
        companyPasswordPolicies:'<',
        createNewPasswordPolicy:'<',
        defaultPolicy:'<',
    },
    controller: Controller,
    templateUrl: require('./password-authentication-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/password-authentication-policy.component.js